import React, { useState, useEffect } from "react";
import CustomDropdown from "./CustomDropdown";
import { CheckIcon, CloseIcon } from "../icons/icons";
import avatarImg from "../../assets/logo/avatar.png";
import CPLogo from "../../assets/logo/cpWhite.png";
import seperator from "./bookingModal.module.scss";
import leftArrow from "../../assets/icons/leftArrow.svg";
import Calendar from "./Calendar";
import TimeSlotColumn from "./TimeSlotColumn";
import styles from "./BookingWizard.module.scss";
import cn from "classnames";
import ConfirmBookingDetails from "./ConfirmBookingDetails";
import { useNavigate } from "react-router-dom";
import Review from "./Review";
import { useGetCustomAvailability } from "../../api/hooks/useCalendar";
import infoIcon from "../../assets/logo/Icon.png";
import Billings from "./Billings";

// const steps = ["Session Details", "Billing method", "Review"];
const steps = ["Session Details", "Review"];

const patientOptions = [
    { value: "1", label: "Andrew Ugbechie" },
    { value: "2", label: "Biggie Balogun" },
    { value: "3", label: "Okpanachi Adaji" },
    { value: "4", label: "Oma Ogenehe" },
];

const durationOptions = [
    { value: "30", label: "30 minutes" },
    { value: "60", label: "60 minutes" },
    { value: "90", label: "90 minutes" },
];

const providerCategories = [
    { value: "general", label: "General" },
    { value: "specialist", label: "Specialist" },
    { value: "therapist", label: "Therapist" },
];

const providersByCategory = {
    general: [
        { value: "smith", label: "Dr. John Smith" },
        { value: "jones", label: "Dr. Emily Jones" },
    ],
    specialist: [
        { value: "johnson", label: "Dr. Sarah Johnson" },
        { value: "brown", label: "Dr. Michael Brown" },
    ],
    therapist: [
        { value: "lee", label: "Dr. Anna Lee" },
        { value: "kim", label: "Dr. David Kim" },
    ],
};

const sessionDurations = [
    { value: "30", label: "30 min" },
    { value: "45", label: "45 min" },
    { value: "60", label: "60 min" },
];

const providers = [
    {
        id: 1,
        name: "Alexander Hamilton",
        initials: "AH",
        times: [
            "8:00am-8:15am",
            "10:00am-10:15am",
            "12:00pm-12:15pm",
            "1:00 pm- 1:15pm",
        ],
    },
    {
        id: 2,
        name: "Marie Curie",
        initials: "MC",
        times: [
            "9:00am-9:15am",
            "11:00am-11:15am",
            "2:00pm-2:15pm",
            "3:00pm-3:15pm",
        ],
    },
    {
        id: 3,
        name: "Nikola Tesla",
        initials: "NT",
        times: [
            "8:30am-8:45am",
            "10:30am-10:45am",
            "1:30pm-1:45pm",
            "4:00pm-4:15pm",
        ],
    },
    {
        id: 3,
        name: "Nikola Tesla",
        initials: "NT",
        times: [
            "8:30am-8:45am",
            "10:30am-10:45am",
            "1:30pm-1:45pm",
            "4:00pm-4:15pm",
        ],
    },
    {
        id: 3,
        name: "Nikola Tesla",
        initials: "NT",
        times: [
            "8:30am-8:45am",
            "10:30am-10:45am",
            "1:30pm-1:45pm",
            "4:00pm-4:15pm",
        ],
    },
    {
        id: 3,
        name: "Nikola Tesla",
        initials: "NT",
        times: [
            "8:30am-8:45am",
            "10:30am-10:45am",
            "1:30pm-1:45pm",
            "4:00pm-4:15pm",
        ],
    },
];

const ProviderTimeList = () => {
    const [expandedProvider, setExpandedProvider] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);

    const toggleProvider = (providerId) => {
        setExpandedProvider(
            expandedProvider === providerId ? null : providerId
        );
    };

    const selectTime = (providerId, time) => {
        setSelectedTime({ providerId, time });
    };

    return (
        <div className={styles.providerTimeList}>
            <h3 className={styles.sectionTitle}>Available Providers & Time</h3>
            {providers.map((provider) => (
                <div key={provider.id} className={styles.providerCard}>
                    <div className={styles.providerHeader}>
                        <div className={styles.providerInfo}>
                            <div className={styles.providerInitials}>
                                {provider.initials}
                            </div>
                            <div className={styles.providerDetails}>
                                <div className={styles.providerName}>
                                    {provider.name}
                                </div>
                                <div
                                    className={styles.availabilityText}
                                    onClick={() => toggleProvider(provider.id)}
                                >
                                    CLICK TO SEE AVAILABLE DATES
                                </div>
                            </div>
                        </div>
                    </div>
                    {expandedProvider === provider.id && (
                        <div className={styles.timeSlotGrid}>
                            {provider.times.map((time, index) => (
                                <div
                                    key={index}
                                    className={`${styles.timeSlotButton} ${
                                        selectedTime?.providerId ===
                                            provider.id &&
                                        selectedTime?.time === time
                                            ? styles.selectedTimeSlot
                                            : ""
                                    }`}
                                    onClick={() =>
                                        selectTime(provider.id, time)
                                    }
                                >
                                    {time}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

const getStepTextColor = (idx, currentStep) => {
    if (idx < currentStep) return "#848588"; // done
    if (idx === currentStep) return "#4E4F51"; // active
    return "#C0C1C2"; // inactive
};

const getStepCircleClassName = (idx, currentStep) => {
    if (idx < currentStep) return styles.stepCircleDone;
    if (idx === currentStep) return styles.stepCircleActive;
    return styles.stepCircleInactive;
};

const BookingWizard = ({ provider, onClose }) => {
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [selectedDuration, setSelectedDuration] = useState(null);
    const [currentStep, setCurrentStep] = useState(0);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [selectedSessionDuration, setSelectedSessionDuration] =
        useState(null);
    const [selectedBillType, setSelectedBillType] = useState(null);
    const [selectedPracticeLocation, setSelectedPracticeLocation] =
        useState(null);
    const [selectedMedicareClaimType, setSelectedMedicareClaimType] =
        useState(null);
    const [selectedMedicareItem, setSelectedMedicareItem] = useState(null);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    const handleBookSession = () => {
        // setShowToast(true);
        setTimeout(() => {
            // setShowToast(false);
            navigate("/appointments");
        }, 2000);
    };

    const { getCustomAvailabilityData } = useGetCustomAvailability();

    console.log("getCustomAvailabilityData =>", getCustomAvailabilityData);

    const handleBook = () => {
        // BookSession({
        //   startTime: "2025-06-28T06:20:00.000Z",
        //   endTime: "2025-06-28T06:50:00.000Z",
        //   patient: "USER_ID_HERE",
        //   provider: "PRACTITIONER_ID_HERE",
        //   practice: "665ee8d74f3336418c5d3160"
        // });
        // TODO: Restore booking logic after fixing hook issues
    };

    // handleBook();

    // Helper functions for formatting
    const formatDate = (date) => {
        if (!date) return "";
        const options = {
            weekday: "short",
            day: "numeric",
            month: "long",
            year: "numeric",
        };
        return new Date(date).toLocaleDateString("en-GB", options);
    };
    const formatTime = (time) => {
        // Example: '8:00am - 9:00am' (implement as needed)
        return time || "";
    };

    return (
        <>
            {/* <Toast show={showToast} /> */}
            <div className={styles.wizardOverlay}>
                <div className={styles.stepperRow}>
                    <img src={CPLogo} alt="CP Logo" className={styles.logo} />
                    <div className={styles.stepperTitle}>
                        <h2>Book a Session</h2>
                        <p>Enter session details below</p>
                    </div>
                    <div className={styles.stepperTitleClose}>
                        <button onClick={onClose}>Exit</button>
                    </div>
                </div>
                <div className={styles.stepperContainer}>
                    {steps.map((step, idx) => (
                        <React.Fragment key={step}>
                            <div className={styles.step}>
                                <div
                                    className={cn(
                                        getStepCircleClassName(idx, currentStep)
                                    )}
                                >
                                    {idx < currentStep ? (
                                        <CheckIcon />
                                    ) : (
                                        <span
                                            className={styles.stepNumber}
                                            style={{
                                                color: getStepTextColor(
                                                    idx,
                                                    currentStep
                                                ),
                                            }}
                                        >
                                            {idx + 1}
                                        </span>
                                    )}
                                </div>
                                <span
                                    className={styles.stepLabel}
                                    style={{
                                        color: getStepTextColor(
                                            idx,
                                            currentStep
                                        ),
                                    }}
                                >
                                    {step}
                                </span>
                            </div>
                            {idx < steps.length - 1 && (
                                <div
                                    className={styles.stepperLine}
                                    style={{
                                        background:
                                            idx < currentStep
                                                ? "#DEB581"
                                                : "#C0C1C2",
                                    }}
                                />
                            )}
                        </React.Fragment>
                    ))}
                </div>
                <div className={styles.mainContent}>
                    <div
                        className={cn({
                            [styles.narrowModal]: currentStep === 0,
                            [styles.wideModal]: currentStep !== 0,
                        })}
                    >
                        {currentStep === 0 && (
                            <div className={styles.dateStepContent}>
                                <div className={styles.dateStepContent}>
                                    <div className={styles.inputsContainer}>
                                        <div className={styles.modalContainer}>
                                            <span
                                                className={styles.DropdownTitle}
                                            >
                                                Choose Provider Type
                                            </span>
                                            <CustomDropdown
                                                options={providerCategories}
                                                selected={selectedCategory}
                                                onChange={(opt) => {
                                                    setSelectedCategory(opt);
                                                    setSelectedProvider(null); // reset provider when category changes
                                                }}
                                                placeholder="Choose Provider"
                                                position="start"
                                                style={{
                                                    background: "transparent",
                                                    maxWidth: "100%",
                                                    height: "20px",
                                                    border: "none",
                                                    paddingLeft: "5px",
                                                    paddingBottom: "5px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        </div>
                                        <div
                                            className={styles.lineBorder}
                                        ></div>
                                        {/* <div className={styles.InputDivision}></div> */}
                                        <div className={styles.modalContainer}>
                                            <span
                                                className={styles.DropdownTitle}
                                            >
                                                Choose Patient
                                            </span>
                                            <CustomDropdown
                                                options={patientOptions}
                                                selected={selectedPatient}
                                                onChange={(opt) => {
                                                    setSelectedPatient(opt);
                                                    setSelectedPatient(null); // reset provider when category changes
                                                }}
                                                placeholder="Choose Patient"
                                                position="start"
                                                style={{
                                                    background: "transparent",
                                                    height: "20px",
                                                    border: "none",
                                                    paddingLeft: "5px",
                                                    // paddingBottom:"5px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        </div>
                                        <div
                                            className={styles.lineBorder}
                                        ></div>
                                        {/* <div className={styles.InputDivision}></div> */}
                                        <div className={styles.modalContainer}>
                                            <span
                                                className={styles.DropdownTitle}
                                            >
                                                Session Duration
                                            </span>
                                            <CustomDropdown
                                                options={durationOptions}
                                                selected={selectedDuration}
                                                onChange={(opt) => {
                                                    setSelectedDuration(opt);
                                                    setSelectedDuration(null); // reset provider when category changes
                                                }}
                                                placeholder="Choose Time"
                                                position="start"
                                                style={{
                                                    background: "transparent",
                                                    height: "20px",
                                                    border: "none",
                                                    paddingLeft: "5px",
                                                    // paddingBottom:"5px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        className={styles.appointmentContainer}
                                    >
                                        <div className={styles.headerSection}>
                                            <div className={styles.headerText}>
                                                <h2
                                                    className={styles.stepTitle}
                                                >
                                                    Choose appointment date
                                                </h2>
                                                <p
                                                    className={
                                                        styles.stepSubtitle
                                                    }
                                                >
                                                    Select preferred date to see
                                                    available providers.
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            className={styles.headerDivider}
                                        ></div>
                                        <div
                                            className={
                                                styles.calendarTimeContainer
                                            }
                                            style={{
                                                paddingLeft: "30px",
                                                marginRight: "30px",
                                                paddingTop: "20px",
                                            }}
                                        >
                                            <div
                                                className={
                                                    styles.calendarContainer
                                                }
                                            >
                                                <div
                                                    className={
                                                        styles.calendarSection
                                                    }
                                                >
                                                    <Calendar
                                                        selectedDate={
                                                            selectedDate
                                                        }
                                                        onDateSelect={
                                                            setSelectedDate
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div
                                                className={
                                                    styles.providerSection
                                                }
                                            >
                                                <div>
                                                    <ProviderTimeList />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={styles.buttonRow}>
                                            <div
                                                className={styles.buttonRowLeft}
                                            >
                                                <button
                                                    className={
                                                        styles.backButton
                                                    }
                                                    onClick={() =>
                                                        setCurrentStep(0)
                                                    }
                                                >
                                                    Back
                                                </button>
                                                <button
                                                    className={
                                                        styles.nextButton
                                                    }
                                                    onClick={() =>
                                                        setCurrentStep(1)
                                                    }
                                                    // disabled={!selectedDate || !selectedTime}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* {currentStep === 1 && <Billings setCurrentStep={setCurrentStep} />} */}
                        {currentStep === 1 && (
                            <Review
                                // patient={selectedPatient ? selectedPatient.label : ""}
                                // provider={selectedProvider ? selectedProvider.label : ""}
                                // date={formatDate(selectedDate)}
                                // time={formatTime(selectedTime)}
                                // practiceLocation={selectedPracticeLocation ? selectedPracticeLocation.label : ""}
                                onBack={() => setCurrentStep(0)}
                                onBook={handleBookSession}
                            />
                        )}
                    </div>
                </div>
                <div className={styles.exitBookingContainer}>
                    <button
                        onClick={onClose}
                        className={styles.exitBookingButton}
                    >
                        <img
                            src={leftArrow}
                            alt="Back"
                            className={styles.exitBookingIcon}
                        />
                        Exit Booking
                    </button>
                </div>
            </div>
        </>
    );
};

export default BookingWizard;
